import React, { FC } from 'react'

import { IconXtrasProps } from './IconXtras.types'
import * as Styled from './styles/IconXtras.style'

import { nonThemeableRules } from '../../ruleSet'

const IconXtras: FC<IconXtrasProps> = ({
  size = nonThemeableRules.defaultSize as number as IconXtrasProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconXtrasProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M116.45 160h-73c-10.8 0-19.5-9.7-19.5-21.7V21.7c0-12 8.7-21.7 19.5-21.7h63c.7 0 1.4.2 2.1.4.1 0 .2.1.3.1.8.4 1.5.9 2.1 1.6.1.2.3.3.4.5l22.6 24.9.1.1c1.3 1.5 2 3.4 2 5.4v105.3c-.1 12-8.8 21.7-19.6 21.7zm-73-152c-6.3 0-11.5 6.1-11.5 13.7v116.6c0 7.6 5.2 13.7 11.5 13.7h73c6.3 0 11.5-6.1 11.5-13.7V32.8L105.45 8h-62zm63.8 128.1h-54.7c-2.5-.1-4.9-1.2-6.7-3l-.1-.1c-1.7-1.8-2.6-4.3-2.5-6.7V57.7c0-2.5.9-5 2.7-6.9l.1-.1c1.8-1.7 4.2-2.7 6.6-2.8h54.7c2.5.1 4.9 1.2 6.6 3 1.8 1.8 2.8 4.3 2.7 6.9v68.4c.1 2.5-.9 5-2.6 6.8-1.8 1.8-4.1 2.9-6.7 3 .1.1 0 .1-.1.1zm-8-8h7.9c.5 0 1-.3 1.3-.6.2-.3.4-.6.3-1v-16.6h-5.5c-1.2 0-2.4-.6-3.2-1.6l-10.9-14.2c-1.1-1.4-1.1-3.4 0-4.9l10.9-14.2c.8-1 1.9-1.6 3.2-1.6h5.5V57.7c0-.4-.1-.9-.4-1.2l-.1-.1c-.3-.3-.7-.5-1.1-.5h-8V60c0 1-.4 2-1.1 2.8l-15.2 16c-.8.7-1.8 1.2-2.9 1.2-1.1 0-2.1-.5-2.9-1.3l-15.1-16c-.7-.7-1.1-1.7-1.1-2.7v-4.1h-7.9c-.5 0-.9.2-1.2.5-.3.3-.5.8-.5 1.3v16.4h5.6c1.2 0 2.4.6 3.2 1.6L70.95 90c1.1 1.4 1.1 3.4 0 4.9L60.05 109c-.8 1-1.9 1.6-3.2 1.6h-5.6v15.7c0 .5.1.9.4 1.3.3.3.7.5 1.2.5h8V124c0-1 .4-2 1.1-2.7l15.1-16c.8-.8 1.8-1.3 2.9-1.3 1.1 0 2.2.4 2.9 1.2l15.3 16c.7.7 1.1 1.7 1.1 2.8v4.1zm-30.4-.1h22.4v-2.4l-11.3-11.8-11.1 11.8v2.4zm-14.2-25.4h.2l7.8-10.2-7.8-10.3h-.2v20.5zm50.6-.7h.2V81.4h-.2l-7.8 10.3 7.8 10.2zm-36.4-43.5 11.1 11.8 11.2-11.8V56h-22.3v2.4z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconXtras
